/* PPF-Kits: EasySearch YMM controller
   - Product pages WITH a [data-ppf-ymm-open] button ("Change vehicle" in the product head), every width:
     the widget moves (never cloned) into a <dialog> inside its slot and nothing stays inline. CSS alone decides
     the look: bottom sheet on phones (< 750px), centred modal from 750px, so an open dialog survives a resize.
     html.ppf-ymm-dialog-page (pre-paint) stays exactly as long as the search lives in the dialog.
     Product pages without such a button keep the inline widget (desktop bar, phone card).
   - Desktop (>= 750px), all other pages: own toggle collapses the panel to a compact heading row; product pages start collapsed
   - Phones on other pages: the widget is a card that STARTS COLLAPSED. The controller owns that state for the
     app's vertical accordion (below 480px) and for its horizontal mode (480-749px), where the app has no accordion:
     one real button over the header row, aria-expanded, and CSS that ignores the app's own max-height writes.
     That also removes the app's resize bug (it closes every widget on an address-bar resize).
   - Prefill once the app has loaded: the product's own vehicle, otherwise the last vehicle searched with Find Kit (30 days).
     Pre-configured kits (trigger with [data-ppf-ymm-kit], see prefill below): the last vehicle only if the kit fits it,
     otherwise the vehicle of the selected kit variant, otherwise nothing; follows later kit changes until the visitor
     picks a vehicle.
   Config: window.PPF_YMM_CFG (snippets/ppf-ymm.liquid). Pre-paint: snippets/ppf-ymm-head.liquid.
   Styles: assets/ppf-ymm.css (mechanics) + assets/ppf-ymm-suchleiste.css (phone card look) */
(function () {
  'use strict';
  if (window.__ppfYmmInit) { unpend(); return; } // loaded twice: still lift the pre-paint classes
  window.__ppfYmmInit = true;

  var CFG = window.PPF_YMM_CFG || {};
  var T = CFG.i18n || {};
  var root = document.documentElement;
  var IS_PRODUCT = CFG.template === 'product';
  var IS_HOME = CFG.template === 'index';
  var PHONE = window.matchMedia('(max-width: 749px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CAN_DIALOG = typeof HTMLDialogElement === 'function' && typeof HTMLDialogElement.prototype.showModal === 'function';
  var TRIGGER = '[data-ppf-ymm-open]';
  var KIT = '[data-ppf-ymm-kit]';
  var DIALOG_PAGE = 'ppf-ymm-dialog-page';
  var LAST_KEY = 'ppf-ymm-last-vehicle';
  var LAST_MS = 30 * 24 * 3600 * 1000;
  var ICON_CHEVRON = '<svg class="ppf-ymm-toggle__icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var S = null;
  var loadedSeen = false; // the app fires easysearch_loaded BEFORE it sets eventStates.easysearch_loaded

  // document.documentElement, not root: this also runs before the var block (double include)
  function unpend() { document.documentElement.classList.remove('ppf-ymm-pending', 'ppf-ymm-pending-sheet', 'ppf-ymm-pending-card'); }
  // fail open: the widget goes back inline, so the dialog-page spacing goes too
  function undialog() { document.documentElement.classList.remove(DIALOG_PAGE); }

  // Theme editor: never move or hide the widget (fail open)
  if (window.Shopify && window.Shopify.designMode) { unpend(); undialog(); return; }

  function ES() { var e = window.easysearch; return e && e.eventStates ? e : null; }
  function mode() { return S ? S.slot.getAttribute('data-ppf-ymm') : ''; }
  function onChange(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn); }
  function firstSelect() { return S.holder.querySelector('.easysearch-field-select-holder select:not(:disabled)') || S.holder.querySelector('select:not(:disabled)'); }
  function focusEl(el) { if (!el || typeof el.focus !== 'function') return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  /* ---------- Setup, once the app has rendered the form ---------- */
  function setup() {
    if (S) return;
    var widget = document.querySelector('#MainContent .easysearch-block-container > .easysearch-main-widget');
    if (!widget) { unpend(); undialog(); return; }
    var container = widget.querySelector('.easysearch-container');
    var holder = container && container.querySelector('.easysearch-holder');
    if (!holder || !holder.querySelector('select')) return; // not rendered yet
    var block = widget.parentElement;
    var slot = block.parentElement;
    if (!holder.id) holder.id = 'ppf-ymm-fields';

    var home = document.createComment('ppf-ymm-home');
    slot.insertBefore(home, block);

    // both toggles sit in the panel, never inside .easysearch-header-holder (the app rewrites it on resize)
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ppf-ymm-toggle';
    toggle.setAttribute('aria-controls', holder.id);
    toggle.innerHTML = '<span class="ppf-ymm-toggle__label"></span>' + ICON_CHEVRON;
    container.insertBefore(toggle, container.firstChild);

    // phones: a real button covering the card header row (the app's header is a div with a click listener)
    var head = container.querySelector('.easysearch-header-holder');
    var ptoggle = document.createElement('button');
    ptoggle.type = 'button';
    ptoggle.className = 'ppf-ymm-ptoggle';
    ptoggle.setAttribute('aria-controls', holder.id);
    ptoggle.setAttribute('aria-expanded', 'false');
    if (head && head.textContent.trim()) {
      if (!head.id) head.id = 'ppf-ymm-heading';
      ptoggle.setAttribute('aria-labelledby', head.id); // the app keeps this element and only rewrites its text
    } else {
      ptoggle.setAttribute('aria-label', T.show || 'Show search');
    }
    container.insertBefore(ptoggle, container.firstChild);

    S = { slot: slot, block: block, container: container, holder: holder, home: home, toggle: toggle,
          label: toggle.firstChild, head: head, ptoggle: ptoggle, collapsed: IS_PRODUCT, cardOpen: false,
          tw: 0, dlg: null, body: null, title: null, downOut: false, openedAt: 0, closedAt: 0 };

    toggle.addEventListener('click', function () { setCollapsed(!S.collapsed, true); });
    ptoggle.addEventListener('click', function () { setCardOpen(!S.cardOpen, true); });
    container.addEventListener('click', function (e) {
      var m = mode();
      if ((m === 'collapsed' || m === 'expanded') && e.target.closest('.easysearch-header-holder')) setCollapsed(!S.collapsed, true);
    });

    onChange(PHONE, applyMode);
    applyMode();
    unpend();
    showTriggers();
    watchTriggers();
    // web fonts change the label widths: measure the pill again
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { S.tw = 0; sizeToggle(); });
    prefill();
  }

  function buildDialog() {
    var dlg = document.createElement('dialog');
    dlg.className = 'ppf-ymm-dialog';
    dlg.id = 'ppf-ymm-dialog';
    dlg.setAttribute('aria-labelledby', 'ppf-ymm-dialog-title');
    dlg.setAttribute('tabindex', '-1'); // takes the focus on tap/click, so the first Tab reaches the close button
    dlg.innerHTML = '<div class="ppf-ymm-dialog__head"><h2 class="ppf-ymm-dialog__title" id="ppf-ymm-dialog-title"></h2>' +
      '<button type="button" class="ppf-ymm-dialog__close">' + ICON_X + '</button></div><div class="ppf-ymm-dialog__body"></div>';
    S.title = dlg.querySelector('.ppf-ymm-dialog__title');
    S.title.textContent = T.title || 'Change vehicle';
    var close = dlg.querySelector('.ppf-ymm-dialog__close');
    close.setAttribute('aria-label', T.close || 'Close');
    close.addEventListener('click', function () { S.closedAt = Date.now(); dlg.close(); });
    // tap or click on the backdrop (outside the dialog box) closes - only a single click that also STARTED there
    // (a drag out of the dialog, e.g. selecting text, ends with a click on the dialog too), and not the second
    // click of a double click whose first click opened the dialog through the trigger now under the backdrop
    function outside(x, y) {
      var r = dlg.getBoundingClientRect();
      return x < r.left || x > r.right || y < r.top || y > r.bottom;
    }
    function down(e) {
      var p = e.touches ? e.touches[0] : e;
      S.downOut = e.target === dlg && !!p && outside(p.clientX, p.clientY);
    }
    if (window.PointerEvent) dlg.addEventListener('pointerdown', down);
    else { dlg.addEventListener('mousedown', down); dlg.addEventListener('touchstart', down, { passive: true }); }
    dlg.addEventListener('click', function (e) {
      var started = S.downOut;
      S.downOut = false;
      if (e.target !== dlg || !started || e.detail > 1 || Date.now() - S.openedAt < 400) return;
      if (outside(e.clientX, e.clientY)) { S.closedAt = Date.now(); dlg.close(); }
    });
    dlg.addEventListener('close', onDialogClose);
    swipeToClose(dlg);
    S.slot.appendChild(dlg);
    S.dlg = dlg;
    S.body = dlg.querySelector('.ppf-ymm-dialog__body');
  }

  // phones (bottom sheet): swipe down to close (Benny 31.10.2026). The head drags always, the list only while it is
  // scrolled to its top and the finger moves down; then the sheet follows the finger 1:1. Released after more than
  // 30 % of its height or with a quick flick it slides out (backdrop fades) and closes, otherwise it springs back.
  function swipeToClose(dlg) {
    var PH = window.matchMedia('(max-width: 749px)'), sw = null;
    dlg.addEventListener('touchstart', function (e) {
      sw = null;
      if (!PH.matches || e.touches.length !== 1 || dlg.classList.contains('is-out')) return;
      var t = e.touches[0];
      sw = { x0: t.clientX, y0: t.clientY, head: !!e.target.closest('.ppf-ymm-dialog__head'), top: S.body.scrollTop <= 0,
             on: false, dy: 0, hist: [[e.timeStamp, t.clientY]] };
    }, { passive: true });
    dlg.addEventListener('touchmove', function (e) {
      if (!sw) return;
      var t = e.touches[0], dy = t.clientY - sw.y0, dx = t.clientX - sw.x0;
      if (!sw.on) {
        if (Math.abs(dy) < 1 && Math.abs(dx) < 1) return;
        // decided on the first move (iOS ignores preventDefault once the list has started scrolling)
        if (dy <= 0 || Math.abs(dx) > dy || !(sw.head || (sw.top && S.body.scrollTop <= 0))) { sw = null; return; }
        sw.on = true;
        dlg.style.transition = 'none';
      }
      if (e.cancelable) e.preventDefault();
      sw.dy = Math.max(0, dy - 4);                                  // 4 px dead zone, then 1:1
      dlg.style.transform = 'translateY(' + sw.dy + 'px)';
      sw.hist.push([e.timeStamp, t.clientY]);
      while (sw.hist.length > 2 && e.timeStamp - sw.hist[0][0] > 100) sw.hist.shift();
    }, { passive: false });
    function release() {
      var s = sw;
      sw = null;
      if (!s || !s.on) return;
      var a = s.hist[0], b = s.hist[s.hist.length - 1], v = b[0] > a[0] ? (b[1] - a[1]) / (b[0] - a[0]) : 0, h = dlg.offsetHeight;
      if (s.dy > h * .3 || (v > .45 && s.dy > 16)) {
        var dur = Math.max(.16, Math.min(.3, (h - s.dy) / Math.max(v, 1.6) / 1000));
        dlg.classList.add('is-out');
        dlg.style.transition = 'transform ' + dur + 's cubic-bezier(.3,.7,.4,1)';
        dlg.style.transform = 'translateY(' + (h + 90) + 'px)';   // + the shadow extension below the sheet
        setTimeout(function () {
          S.closedAt = Date.now();
          dlg.close();
          dlg.classList.remove('is-out');
          dlg.style.transition = ''; dlg.style.transform = '';
        }, dur * 1000 + 20);
      } else {
        dlg.style.transition = 'transform .3s cubic-bezier(.2,.8,.2,1)';
        dlg.style.transform = '';
        setTimeout(function () { if (!sw) dlg.style.transition = ''; }, 320);
      }
    }
    dlg.addEventListener('touchend', release);
    dlg.addEventListener('touchcancel', release);
  }

  /* ---------- Modes: popup (any width) · native (phones) · collapsed | expanded (desktop) ---------- */
  // the dialog needs something that opens it: without a trigger the page keeps the inline widget.
  // Not width dependent: the pre-paint class html.ppf-ymm-pending-sheet hides the inline widget at every width.
  // Startseite am Handy (User 21.10.2026): "Choose your car" im Video-Hero (sections/pk-home-hero-m.liquid) oeffnet dieselbe
  // Suche als Bottom-Sheet wie "Change vehicle" auf der Produktseite; am Desktop bleibt dort die Suchleiste inline.
  // Dieser Fall IST breitenabhaengig: onChange(PHONE, applyMode) schaltet beim Drehen bzw. Breitenwechsel um.
  function sheetWanted() {
    if (!CAN_DIALOG || !document.querySelector(TRIGGER)) return false;
    if (IS_PRODUCT) return true;
    return IS_HOME && PHONE.matches && !!document.querySelector('[data-pk-hv] ' + TRIGGER);
  }

  function applyMode() {
    if (!S) return;
    if (sheetWanted()) {
      if (!S.dlg) buildDialog();
      if (S.block.parentNode !== S.body) S.body.appendChild(S.block);
      setMode('popup');
      return;
    }
    // leaving the dialog while it is open (its trigger has gone): the search stays open inline,
    // instead of collapsing behind the pill
    if (S.dlg && S.dlg.open) { S.collapsed = false; S.cardOpen = true; S.silent = true; S.dlg.close(); }
    if (S.block.parentNode !== S.slot) S.slot.insertBefore(S.block, S.home.nextSibling);
    setMode(PHONE.matches ? 'native' : (S.collapsed ? 'collapsed' : 'expanded'));
  }

  function setMode(m) {
    S.slot.setAttribute('data-ppf-ymm', m);
    root.classList.toggle(DIALOG_PAGE, m === 'popup'); // same task as unpend(): no frame without either class
    if (m === 'collapsed' || m === 'expanded') {
      var open = m === 'expanded';
      S.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      S.label.textContent = open ? (T.hide || 'Hide search') : (T.show || 'Show search');
      sizeToggle();
    }
    if (m === 'native') {
      S.slot.setAttribute('data-ppf-ymm-card', S.cardOpen ? 'open' : 'closed');
      S.ptoggle.setAttribute('aria-expanded', S.cardOpen ? 'true' : 'false');
      if (S.head) S.head.setAttribute('aria-hidden', 'true'); // the button carries the same name
    } else {
      S.slot.removeAttribute('data-ppf-ymm-card');
      if (S.head) S.head.removeAttribute('aria-hidden');
    }
    ariaTriggers();
  }

  // pill width = the wider of both labels, so it never moves when the label changes
  function sizeToggle() {
    var m = mode();
    if (S.tw || (m !== 'collapsed' && m !== 'expanded')) return;
    var cur = S.label.textContent;
    var w = 0;
    S.slot.style.setProperty('--ppf-ymm-tw', '0px');
    [T.show || 'Show search', T.hide || 'Hide search'].forEach(function (t) {
      S.label.textContent = t;
      w = Math.max(w, S.toggle.getBoundingClientRect().width);
    });
    S.label.textContent = cur;
    S.tw = Math.ceil(w);
    if (S.tw) S.slot.style.setProperty('--ppf-ymm-tw', S.tw + 'px');
    else S.slot.style.removeProperty('--ppf-ymm-tw');
  }

  // fields fade in when the user opens them
  function reveal() {
    S.slot.classList.remove('ppf-ymm-reveal');
    void S.slot.offsetWidth;
    S.slot.classList.add('ppf-ymm-reveal');
    clearTimeout(S.revealTimer);
    S.revealTimer = setTimeout(function () { S.slot.classList.remove('ppf-ymm-reveal'); }, 400);
  }

  function setCollapsed(c, user) {
    S.collapsed = c;
    if (PHONE.matches) return;
    setMode(c ? 'collapsed' : 'expanded');
    if (!c && user) reveal();
  }

  // phones, inline card: our own open state, so no resize of the app can close it
  function setCardOpen(open, user) {
    S.cardOpen = open;
    if (mode() !== 'native') return;
    setMode('native');
    if (open && user) reveal();
  }

  /* ---------- Dialog (sheet / modal) ---------- */
  function openDialog(trigger, keyboard) {
    var d = S.dlg;
    if (!d || d.open) return;
    refillKit();
    S.returnFocus = trigger || document.activeElement;
    S.silent = false;
    S.downOut = false;
    S.openedAt = Date.now();
    d.showModal();
    lock(true);
    S.body.scrollTop = 0;
    ariaTriggers();
    // keyboard: straight into the first field; tap/click: the dialog itself, so no focus ring sits on a prefilled field
    focusEl((keyboard && firstSelect()) || d);
  }

  function onDialogClose() {
    // the close event comes with the next rendered frame: a dialog reopened in between keeps its lock and focus
    if (S.dlg.open) return;
    lock(false);
    ariaTriggers();
    var t = S.returnFocus;
    S.returnFocus = null;
    if (!S.silent && t && t.isConnected) focusEl(t);
    S.silent = false;
  }

  // Scroll lock through our own class only: html.ppf-ymm-locked sets overflow:hidden on html (the scroller
  // here) and, on phones, on body; from 750px body stays as it is, so the sticky header and product column
  // do not move (assets/ppf-ymm.css). Dawn's body.overflow-hidden belongs to the drawers, so we never write
  // or remove it. A classic desktop scrollbar keeps its gutter (ppf-ymm-locked-gutter), otherwise the page
  // jumps sideways.
  function lock(on) {
    if (on && root.classList.contains('ppf-ymm-locked')) return; // already locked: keep the gutter measured unlocked
    var gutter = on && window.innerWidth - root.clientWidth > 0;
    root.classList.toggle('ppf-ymm-locked-gutter', gutter);
    root.classList.toggle('ppf-ymm-locked', on);
  }

  /* ---------- "Change vehicle" trigger ---------- */
  function openFrom(t, keyboard) {
    var m = mode();
    if (m === 'popup') { openDialog(t, keyboard); return; }
    if (m === 'collapsed') setCollapsed(false, true);
    if (m === 'native') setCardOpen(true, true);
    scrollToPanel();
    flash();
    if (keyboard) focusEl(firstSelect());
  }

  function scrollToPanel() {
    var r = S.container.getBoundingClientRect();
    var vh = window.innerHeight;
    var header = document.querySelector('.section-header');
    var stickyH = header && /sticky|fixed/.test(getComputedStyle(header).position) ? header.offsetHeight : 0;
    var covered = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    // already fully in view below the header: do not move the page (it would also hide an on-scroll-up header)
    if (r.top >= covered && r.bottom <= vh) return;
    var y = window.pageYOffset;
    var top = r.top + y - 16;
    var sticky = document.querySelector('sticky-header');
    var type = sticky ? sticky.getAttribute('data-sticky-type') : '';
    // room for a sticky header, unless it hides while scrolling down or the panel would not fit below it (landscape phones)
    if (stickyH && !(type === 'on-scroll-up' && top > y) && r.height + stickyH + 32 <= vh) top -= stickyH;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCE.matches ? 'auto' : 'smooth' });
  }

  function flash() {
    var el = S.block;
    clearTimeout(S.flashTimer);
    clearTimeout(S.flashEnd);
    el.classList.remove('ppf-ymm-flash');
    S.flashTimer = setTimeout(function () {
      void el.offsetWidth;
      el.classList.add('ppf-ymm-flash');
      S.flashEnd = setTimeout(function () { el.classList.remove('ppf-ymm-flash'); }, 2400);
    }, REDUCE.matches ? 0 : 450);
  }

  // what the trigger does in the current mode, for screen readers
  function ariaTriggers() {
    if (!S) return;
    var m = mode();
    var list = document.querySelectorAll(TRIGGER);
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (m === 'popup') {
        b.setAttribute('aria-haspopup', 'dialog');
        b.setAttribute('aria-controls', S.dlg.id);
        b.setAttribute('aria-expanded', S.dlg.open ? 'true' : 'false');
      } else {
        b.removeAttribute('aria-haspopup');
        b.setAttribute('aria-controls', S.holder.id);
        if (m === 'native') b.setAttribute('aria-expanded', S.cardOpen ? 'true' : 'false');
        else if (m === 'collapsed' || m === 'expanded') b.setAttribute('aria-expanded', m === 'expanded' ? 'true' : 'false');
        else b.removeAttribute('aria-expanded');
      }
    }
  }

  function showTriggers() {
    var list = document.querySelectorAll(TRIGGER + '[hidden]');
    for (var i = 0; i < list.length; i++) list[i].hidden = false;
    ariaTriggers();
  }

  function containsTrigger(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType === 1 && (n.matches(TRIGGER) || (n.firstElementChild && n.querySelector(TRIGGER)))) return true;
    }
    return false;
  }

  // product-info re-renders can bring the button back with [hidden]; only added nodes that carry a trigger count
  function watchTriggers() {
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (!containsTrigger(records[i].addedNodes)) continue;
        showTriggers();
        if (mode() !== 'popup') applyMode();
        return;
      }
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest(TRIGGER) : null;
    if (!t) return;
    e.preventDefault();
    // the second click of a double click that has just closed the dialog (on the backdrop or X above the trigger)
    if (!S || (e.detail > 1 && Date.now() - S.closedAt < 600)) return;
    openFrom(t, e.detail === 0);
  });

  // #ymm / #ymm-search jump links (home, brand pages): open first, their own handler scrolls
  document.addEventListener('click', function (e) {
    if (!S) return;
    var a = e.target.closest ? e.target.closest('a[href$="#ymm"], a[href="#ymm-search"]') : null;
    if (!a || a.pathname !== location.pathname) return;
    var m = mode();
    if (m === 'collapsed') setCollapsed(false, true);
    else if (m === 'native') setCardOpen(true, true);
    else if (m === 'popup') { e.preventDefault(); e.stopImmediatePropagation(); openDialog(a, e.detail === 0); }
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && S && S.dlg && S.dlg.open) { S.silent = true; S.dlg.close(); }
  });

  /* ---------- Prefill: product vehicle, else the last Find Kit search ---------- */
  // remember the vehicle of every Find Kit click (link navigation, the app fires this right before)
  document.addEventListener('easysearch_params_saved', function (e) {
    var h = e.detail && e.detail.holder;
    var idx = h && h.esparams ? h.esparams.index : '';
    if (typeof idx !== 'string' || !idx.replace(/,/g, '')) return;
    try { localStorage.setItem(LAST_KEY, JSON.stringify({ index: idx, ts: Date.now() })); } catch (err) { /* storage blocked */ }
  });

  function lastVehicle() {
    try {
      var v = JSON.parse(localStorage.getItem(LAST_KEY) || 'null');
      if (v && typeof v.index === 'string' && typeof v.ts === 'number' && Date.now() - v.ts < LAST_MS) return v.index;
    } catch (err) { /* storage blocked or invalid */ }
    return '';
  }

  // only full tree paths have a collection URL (intermediate indexes return option names)
  function leafUrl(E, idx) {
    var u = idx ? E.getUrlByIndex(idx) : '';
    return typeof u === 'string' && /^(\/|https?:)/.test(u) ? u : '';
  }

  // kits for exactly one vehicle (one EasySearch vehicle tag); accessories fit many
  function productVehicle(E) {
    if (!IS_PRODUCT || typeof E.fitmentGetFirstReferencedTreeIndex !== 'function') return '';
    var tags = E.pageInfo && E.pageInfo.productTagsSet ? Array.from(E.pageInfo.productTagsSet) : [];
    if (tags.filter(function (t) { return /-esi\d+$/i.test(t); }).length !== 1) return '';
    return E.fitmentGetFirstReferencedTreeIndex() || '';
  }

  /* Pre-configured kits: one product, many vehicles (one EasySearch fitment per vehicle, several per kit variant).
     1. the last Find Kit vehicle, if it is one of the product's fitments
     2. else the vehicle of the selected kit variant, if exactly one fitment matches it:
        newest year of the variant's year range, make and model words in the variant title, the same generation
        (the words in quotes or brackets: 'Model Y "Juniper"' = 'Model Y (Juniper)', none = none), then the trim
        named in the title (the longest match wins). A title without a trim takes the one trim that no sibling
        variant of the same vehicle names (e.g. 'Model 3 "Highland"' next to 'Model 3 "Highland" Performance').
        Works on translated titles too: only years, names, words in quotes and the fitments' trims are compared.
     3. else nothing */
  function isKit() { return !!document.querySelector(TRIGGER + KIT); }

  // one tree leaf (a full vehicle) that this product fits; the key keeps its trailing comma, as getCurrentIndex() returns it
  function fitsProduct(E, key, here) {
    var v = key ? (E.tree || {})[key] : null;
    return !!(v && v[0] && key.slice(0, -1).split(',').length === E.settings.fields.length &&
      E.fitmentCheck(v[0], here || E.getUrlDetails(window.location.href), true));
  }

  // the product's fitments that a kit variant can name: only vehicles whose make and model words appear in some
  // variant title are checked (the app's per-vehicle check is the slow part; the whole tree has thousands of leaves)
  function kitFitments(E, titles) {
    if (S.fits) return S.fits;
    var n = E.settings.fields.length;
    var here = E.getUrlDetails(window.location.href);
    var tw = words(titles.join(' '));
    var named = {};
    function inTitles(s) {
      if (!Object.prototype.hasOwnProperty.call(named, s)) named[s] = within(words(s), tw);
      return named[s];
    }
    var out = [];
    Object.keys(E.tree || {}).forEach(function (k) {
      var p = k.slice(0, -1).split(',');
      // fields: year, make, model, variant (trim)
      if (p.length !== n || !inTitles(p[1] || '') || !inTitles(p[2] || '') || !fitsProduct(E, k, here)) return;
      out.push({ key: k, year: p[0], make: p[1] || '', model: p[2] || '', trim: n > 3 ? p[n - 1] : '' });
    });
    S.fits = out;
    return out;
  }

  var QUOTES = /["“”„«»()[\]]/g;
  function words(t) { return String(t || '').toLowerCase().replace(QUOTES, ' ').split(/[^0-9a-zÀ-ɏ]+/).filter(Boolean); }
  function generation(t) {
    var parts = String(t || '').replace(QUOTES, '"').split('"');
    var g = [];
    for (var i = 1; i < parts.length; i += 2) g = g.concat(words(parts[i]));
    return g.sort().join(' ');
  }
  function within(a, b) { for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) === -1) return false; return true; }
  function newestYear(t) {
    var y = String(t || '').match(/(?:^|\D)(?:19|20)\d\d(?!\d)/g) || [];
    y = y.map(function (m) { return +m.replace(/\D/g, ''); });
    return y.length ? String(Math.max.apply(null, y)) : '';
  }
  function sameVehicle(f, tw, gen) {
    return within(words(f.make), tw) && within(words(f.model), tw) && generation(f.model) === gen;
  }

  function kitVehicle(fits, title, siblings) {
    var year = newestYear(title);
    var tw = words(title);
    var gen = generation(title);
    if (!year) return '';
    var cands = fits.filter(function (f) { return f.year === year && sameVehicle(f, tw, gen); });
    if (!cands.length) return '';
    var named = cands.filter(function (f) { return f.trim && within(words(f.trim), tw); });
    if (named.length) {
      var most = Math.max.apply(null, named.map(function (f) { return words(f.trim).length; }));
      named = named.filter(function (f) { return words(f.trim).length === most; });
      return named.length === 1 ? named[0].key : '';
    }
    var claimed = {};
    siblings.forEach(function (o) {
      if (o === title || generation(o) !== gen) return;
      var ow = words(o);
      cands.forEach(function (f) { if (f.trim && sameVehicle(f, ow, gen) && within(words(f.trim), ow)) claimed[f.key] = true; });
    });
    var rest = cands.filter(function (f) { return !claimed[f.key]; });
    return rest.length === 1 ? rest[0].key : '';
  }

  // variant titles in the page language: pk_head's map, else the analytics data Shopify puts on product pages
  function variantTitles() {
    var m = window.PK_SEL_VARIANTS;
    if (m && typeof m === 'object') return m;
    var out = {};
    try {
      (window.ShopifyAnalytics.meta.product.variants || []).forEach(function (v) { out[v.id] = v.public_title || ''; });
    } catch (err) { /* no data */ }
    return out;
  }
  function currentVariant() {
    var el = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = el && el.value;
    if (!id) { var m = /[?&]variant=(\d+)/.exec(window.location.search); id = m ? m[1] : ''; }
    return String(id || '');
  }

  function kitIndex(E) {
    var last = lastVehicle();
    if (fitsProduct(E, last)) return last;
    var map = variantTitles();
    var title = map[currentVariant()];
    if (typeof title !== 'string' || !title) return '';
    var all = Object.keys(map).map(function (k) { return String(map[k] || ''); });
    return kitVehicle(kitFitments(E, all), title, all);
  }

  /* Bundle kits (Full / Full Front End Kit with a parts_product, pk_head adds .pk-head--bkit): one vehicle, but the app does not
     know the kit product, so there is no fitment to check and no vehicle in the variant titles. The vehicle is read from the
     head (data-pk-vehicle = "Tesla Model Y (Juniper) Premium 2026") and matched against the whole tree by year, make, model
     (same generation words) and trim - the same matching as kitVehicle(). Nothing found: the form stays empty. */
  function isBundleKit() { return !!document.querySelector('.pk-head--bkit'); }
  function bundleKitIndex(E) {
    var el = document.querySelector('[data-pk-vehicle]');
    var title = el ? (el.getAttribute('data-pk-vehicle') || '') : '';
    if (!title) { var h = document.querySelector('.pk-head h1, .product__title h1, h1'); title = h ? h.textContent : ''; }
    title = String(title).replace(/\s+/g, ' ').trim();
    if (!title) return '';
    var n = E.settings.fields.length;
    var tw = words(title);
    var out = [];
    Object.keys(E.tree || {}).forEach(function (k) {
      var p = k.slice(0, -1).split(',');
      if (p.length !== n || !p[1] || !p[2]) return;
      if (!within(words(p[1]), tw) || !within(words(p[2]), tw)) return;
      out.push({ key: k, year: p[0], make: p[1], model: p[2], trim: n > 3 ? p[n - 1] : '' });
    });
    return kitVehicle(out, title, [title]);
  }

  function fill(E, idx) {
    S.auto = idx;
    E.searchFormFillAllSelects(S.holder, idx ? idx.split(',').slice(0, E.settings.fields.length) : []);
  }

  // runs once after easysearch_loaded; no focus, no mode change, and it never opens the card
  function prefill() {
    var E = ES();
    if (!S || S.filled || !E || !(loadedSeen || E.eventStates.easysearch_loaded)) return;
    S.filled = true;
    try {
      var form = E.settings && E.settings.form;
      if (!form || form.main_autosubmit || typeof E.searchFormFillAllSelects !== 'function') return;
      if (E.getCurrentIndex(S.holder).replace(/,/g, '')) return; // chosen already, e.g. the app's own preselect after Find Kit
      var idx;
      if (IS_PRODUCT && isKit() && isBundleKit()) {
        idx = bundleKitIndex(E);
      } else if (IS_PRODUCT && isKit()) {
        S.kit = true;
        subscribeVariantChange();
        idx = kitIndex(E);
      } else {
        idx = productVehicle(E);
        if (!leafUrl(E, idx)) idx = lastVehicle();
      }
      if (!leafUrl(E, idx)) return; // vehicle no longer in the tree
      fill(E, idx);
    } catch (err) { /* keep the form empty */ }
  }

  // kits: another kit variant, another vehicle - as long as the form holds our own prefill or nothing
  function refillKit() {
    var E = ES();
    if (!S || !S.kit || !E) return;
    try {
      var cur = E.getCurrentIndex(S.holder);
      var chosen = cur.replace(/,/g, '') ? cur : '';
      if (chosen && chosen !== S.auto) return; // the visitor picked a vehicle: keep it
      var idx = kitIndex(E);
      if (!leafUrl(E, idx)) idx = '';
      if (idx !== chosen) fill(E, idx);
    } catch (err) { /* keep the form as it is */ }
  }
  var refillTimers = [];
  function scheduleRefill() {
    if (!S || !S.kit) return;
    refillTimers.forEach(clearTimeout);
    refillTimers = [setTimeout(refillKit, 150), setTimeout(refillKit, 800)];
  }
  // Dawn's product-info sets the variant id and fires change on it; EVS swatches and theme radios fire change too
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-selects, easy-variant-swatch, form[action*="/cart/add"]')) scheduleRefill();
  }, true);
  // Dawn's pub/sub (assets/pubsub.js, constants.js): PUB_SUB_EVENTS is a global const, not a window property
  function subscribeVariantChange() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, scheduleRefill);
      }
    } catch (err) { /* no pub/sub */ }
  }

  /* ---------- Keep-open guard for widgets we do not control ---------- */
  // The app closes its accordion on EVERY resize, also when only the address bar moves.
  // Inside our card the state is ours (the header button intercepts the clicks), so this only
  // matters if the controller never took over, e.g. a widget outside the expected markup.
  var userToggleAt = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.easysearch-main-widget .easysearch-header-holder')) userToggleAt = Date.now();
  }, true);

  function guard(c) {
    if (c.__ppfKeepOpen || typeof MutationObserver !== 'function') return;
    c.__ppfKeepOpen = true;
    var widthAtOpen = c.classList.contains('easysearch-opened') ? window.innerWidth : null;
    new MutationObserver(function (records) {
      // records arrive batched: any of them may carry the class the app has just removed
      var wasOpen = false;
      for (var i = 0; i < records.length; i++) {
        if ((records[i].oldValue || '').indexOf('easysearch-opened') !== -1) { wasOpen = true; break; }
      }
      var isOpen = c.classList.contains('easysearch-opened');
      if (!wasOpen && isOpen) { widthAtOpen = window.innerWidth; return; }
      if (!wasOpen || isOpen) return;
      if (Date.now() - userToggleAt < 700) return;
      if (!c.classList.contains('easysearch-vertical-mode')) return;
      if (window.innerWidth !== widthAtOpen) return;
      if (c.closest('.ppf-ymm-dialog') || c.closest('[data-ppf-ymm-card]')) return;
      var h = c.querySelector('.easysearch-holder');
      c.classList.add('easysearch-opened');
      if (h) h.style.maxHeight = h.scrollHeight + 'px';
    }).observe(c, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  function guardAll() {
    var list = document.querySelectorAll('#MainContent .easysearch-main-widget .easysearch-container');
    for (var i = 0; i < list.length; i++) guard(list[i]);
  }

  /* ---------- Boot (the app may render before or after this script) ---------- */
  document.addEventListener('easysearch_rendered', function () { setup(); guardAll(); });
  document.addEventListener('easysearch_loaded', function () { loadedSeen = true; setup(); prefill(); });

  function boot() {
    var E = ES();
    if (E && E.eventStates.easysearch_rendered) setup();
    else if (!document.querySelector('#MainContent .easysearch-block-container')) { unpend(); undialog(); }
    guardAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
